<ng-template #unconfiguredRouteRef>
  <h2 mat-dialog-title>Unconfigured Route</h2>
  <mat-dialog-content class="mat-typography">
    <p>This route has not yet been configured by the administrator.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>OK</button>
  </mat-dialog-actions>
</ng-template>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    class="sidenav"
    #drawer
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
    ><div [routerLink]="['/home']" class="app-nav-brand-container">
      <mat-icon
        style="height: 150px; width: 150px"
        svgIcon="soleran"
        color="primary"
      ></mat-icon>
    </div>
    <mat-nav-list>
      <mat-accordion class="app-nav-accordion">
        <mat-expansion-panel
          #panel
          *ngFor="let g of groups$ | async"
          [class.mat-elevation-z0]="true"
        >
          <mat-expansion-panel-header
            style="margin: 8px; border-radius: 8px"
            [class.app-nav-expanded-selected]="panel.expanded"
          >
            <mat-panel-title>
              <mat-icon>{{ g.suite.icon }}</mat-icon>
              <span>
                {{ g.suite.name }}
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="app-nav-expansion-panel-body">
            <mat-divider [vertical]="true"> </mat-divider>
            <div class="app-nav-expansion-panel-list-item-container">
              <mat-list-item
                class="app-nav-list-item"
                *ngFor="let ref of g.appRefs"
                (click)="onNavItemClick(ref)"
              >
                <div class="app-nav-list-item-text">
                  <span>{{ ref.app.name }} </span>
                  <span style="flex: 1 1 auto"></span>
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </mat-list-item>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content style="box-sizing: border-box">
    <app-topbar class="mat-elevation-z7">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    </app-topbar>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
